import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { trackPageChange } from "../../utils/behaviorTracking";

class RouteChangeTracker extends React.Component<RouteComponentProps> {
  componentDidMount() {
    trackPageChange();
  }

  componentDidUpdate(prevProps: RouteComponentProps) {
    const { location } = this.props;
    if (
      location.pathname !== prevProps.location.pathname ||
      location.search !== prevProps.location.search ||
      location.hash !== prevProps.location.hash
    ) {
      trackPageChange();
    }
  }

  render() {
    return null;
  }
}

export default withRouter(RouteChangeTracker);
